// svg4everybody.js (ESM version)
// Original: svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody

function embed(parent, svg, target) {
    if (target) {
        const fragment = document.createDocumentFragment();
        const viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");

        if (viewBox) svg.setAttribute("viewBox", viewBox);

        const clone = target.cloneNode(true);
        while (clone.childNodes.length) {
            fragment.appendChild(clone.firstChild);
        }

        parent.appendChild(fragment);
    }
}

function loadreadystatechange(xhr) {
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            let cachedDocument = xhr._cachedDocument;

            if (!cachedDocument) {
                cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument("");
                cachedDocument.body.innerHTML = xhr.responseText;
                xhr._cachedTarget = {};
            }

            xhr._embeds.splice(0).map(function (item) {
                let target = xhr._cachedTarget[item.id];
                if (!target) {
                    target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id);
                }
                embed(item.parent, item.svg, target);
            });
        }
    };

    xhr.onreadystatechange();
}

function getSVGAncestor(node) {
    let svg = node;
    while (svg && svg.nodeName.toLowerCase() !== "svg") {
        svg = svg.parentNode;
    }
    return svg;
}

export default function svg4everybody(rawopts = {}) {
    const opts = Object(rawopts);

    const newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/;
    const webkitUA = /\bAppleWebKit\/(\d+)\b/;
    const olderEdgeUA = /\bEdge\/12\.(\d+)\b/;
    const edgeUA = /\bEdge\/.(\d+)\b/;

    const inIframe = window.top !== window.self;

    const polyfill = "polyfill" in opts
        ? opts.polyfill
        : newerIEUA.test(navigator.userAgent) ||
          ((navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547) ||
          ((navigator.userAgent.match(webkitUA) || [])[1] < 537) ||
          (edgeUA.test(navigator.userAgent) && inIframe);

    const requests = {};
    const requestAnimationFrameFn = window.requestAnimationFrame || setTimeout;
    const uses = document.getElementsByTagName("use");

    let numberOfSvgUseElementsToBypass = 0;

    function oninterval() {
        for (let index = 0; index < uses.length;) {
            const use = uses[index];
            const parent = use.parentNode;
            const svg = getSVGAncestor(parent);

            let src = use.getAttribute("xlink:href") || use.getAttribute("href");
            if (!src && opts.attributeName) {
                src = use.getAttribute(opts.attributeName);
            }

            if (svg && src) {
                if (polyfill) {
                    if (!opts.validate || opts.validate(src, svg, use)) {
                        parent.removeChild(use);

                        const srcSplit = src.split("#");
                        const url = srcSplit.shift();
                        const id = srcSplit.join("#");

                        if (url.length) {
                            let xhr = requests[url];

                            if (!xhr) {
                                xhr = requests[url] = new XMLHttpRequest();
                                xhr.open("GET", url);
                                xhr.send();
                                xhr._embeds = [];
                            }

                            xhr._embeds.push({ parent, svg, id });

                            loadreadystatechange(xhr);
                        } else {
                            embed(parent, svg, document.getElementById(id));
                        }
                    } else {
                        index++;
                        numberOfSvgUseElementsToBypass++;
                    }
                }
            } else {
                index++;
            }
        }

        if (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) {
            requestAnimationFrameFn(oninterval, 67);
        }
    }

    if (polyfill) oninterval();
}